<template>
  <div class="view-marketplace pb-9">
    <h1 class="page-title">
      Mercado de afiliação
      <small>Veja os produtos disponíveis para afiliação.</small>
    </h1>
    <div class="row d-flex justify-content-between align-items-center">
      <!-- <div class="row d-flex align-items-center"> -->
      <div class="col-lg-3 pr-lg-0" v-if="searchTerm || searchByCategory">
        <form-group
          v-model="form.category_select"
          select
          id="select_category"
          :options="[{ id: 'all', name: 'Todos as categorias' }, ...categories]"
        />
      </div>

      <div class="col-lg-4">
        <form-group
          id="search-input"
          v-model="searchTerm"
          placeholder="Pesquisar produto"
          icon="icon-search"
        />
      </div>

      <div
        class="px-lg-0"
        :class="{
          'col-lg-5': !(searchTerm || searchByCategory),
          'col-lg-2': searchTerm || searchByCategory
        }"
      >
        <button class="btn btn-outline-primary px-5" @click="showFilter = true">
          <i class="icon-filter mr-2"></i> Filtrar produtos
        </button>
      </div>

      <!-- </div> -->
      <div class="col-lg-3">
        <form-group
          isSwitch
          id="only-language"
          v-model="showOnlyLanguage"
          label="Ver produtos no meu idioma"
        />
      </div>
    </div>

    <div v-if="!results">
      <div class="pb-6 pt-5">
        <banner :items="[{ id: 1 }, { id: 2 }, { id: 3 }]" />
      </div>

      <action-dispatcher action="product/getCategories">
        <categories @select="selectCategory" :items="categories" />
      </action-dispatcher>

      <div class="py-9 mt-9">
        <products-carousel title="Mais quentes" :items="hotItems" />
      </div>

      <div class="pt-5 pb-9">
        <products-carousel
          title="Mais queridos"
          :items="hotItems.slice().reverse()"
        />
      </div>
    </div>

    <div v-else>
      <div
        class="d-flex align-items-center mt-5 mb-5 mb-lg-2 justify-content-start"
      >
        <h5 v-if="searchByCategory || searchTerm" class="mb-0 mr-3">
          {{ searchByCategory || searchTerm }}
        </h5>
        <small class="text-secondary"
          >{{ searchByCategory.length || searchTerm.length }} Resultados</small
        >
      </div>

      <div
        class="d-flex flex-wrap align-items-center justify-content-between mb-5"
      >
        <div class="d-flex">
          <tag class="mr-3" @click="removeTag" title="Português" />
          <tag @click="removeTag" :title="searchTerm || searchByCategory" />
        </div>

        <form-group
          select
          id="order"
          v-model="orderBy"
          placeholder="Ordernar por"
          :options="[
            { id: 'name', name: 'Nome' },
            { id: 'popularity', name: 'Popularidade' },
            { id: 'satisfaction', name: 'Satisfação' },
            { id: 'points', name: 'Pontuação' }
          ]"
        />
      </div>
      <search-results :items="hotItems" />
    </div>

    <responsive-modal v-model="showFilter">
      <div class="p-3">
        <h5>
          Filtros
        </h5>
        <small class="text-secondary"
          >Selecione os filtros e depois clique em aplicar</small
        >

        <div class="mt-5">
          <form-group
            select
            id="affiliation_type"
            v-model="form.affiliation_type"
            label="Tipo de afiliação"
            placeholder="Escolha uma opção"
            :options="[
              { id: 1, name: 'Opção 1' },
              { id: 2, name: 'Opção 2' }
            ]"
          />
        </div>
        <form-group
          select
          id="commission_percent"
          v-model="form.commission_percent"
          label="% Comissão"
          placeholder="Escolha uma opção"
          :options="[
            { id: 1, name: 'Opção 1' },
            { id: 2, name: 'Opção 2' }
          ]"
        />
        <form-group
          select
          id="commission_rule"
          v-model="form.commission_rule"
          label="Regra de comissionamento"
          placeholder="Escolha uma opção"
          :options="[
            { id: 1, name: 'Opção 1' },
            { id: 2, name: 'Opção 2' }
          ]"
        />
        <form-group
          select
          id="language"
          v-model="form.language"
          label="Idioma"
          placeholder="Escolha uma opção"
          :options="[
            { id: 1, name: 'Opção 1' },
            { id: 2, name: 'Opção 2' }
          ]"
        />
        <form-group
          select
          id="format"
          v-model="form.format"
          label="Formato de Produto"
          placeholder="Escolha uma opção"
          :options="[
            { id: 1, name: 'Opção 1' },
            { id: 2, name: 'Opção 2' }
          ]"
        />
        <form-group
          select
          id="price"
          v-model="form.price"
          label="Preço"
          placeholder="Escolha uma opção"
          :options="[
            { id: 1, name: 'Opção 1' },
            { id: 2, name: 'Opção 2' }
          ]"
        />
        <form-group
          select
          id="currency"
          v-model="form.currency"
          label="Moeda"
          placeholder="Escolha uma opção"
          :options="[
            { id: 1, name: 'Opção 1' },
            { id: 2, name: 'Opção 2' }
          ]"
        />
        <form-group
          select
          id="country"
          v-model="form.country"
          label="País"
          placeholder="Escolha uma opção"
          :options="[
            { id: 1, name: 'Opção 1' },
            { id: 2, name: 'Opção 2' }
          ]"
        />

        <div class="my-6">
          <strong>Ferramentas</strong>
          <checkbox :values="toolsOptions" />
        </div>

        <div class="d-flex justify-content-between">
          <button
            class="btn btn-outline-secondary btn-fixed-size mr-2"
            @click="showFilter = false"
          >
            Limpar Filtros
          </button>
          <button
            class="btn btn-primary btn-fixed-size ml-2"
            @click="showFilter = false"
          >
            Aplicar Filtros
          </button>
        </div>
      </div>
    </responsive-modal>
  </div>
</template>
<script>
import Banner from "@/components/marketplace/Banner";
import Categories from "@/components/marketplace/Categories";
import ProductsCarousel from "@/components/marketplace/ProductsCarousel";
import searchResults from "@/components/marketplace/SearchResults";
import Tag from "@/components/marketplace/Tag";
import { formFields } from "@/functions/helpers";
import { mapState } from "vuex";

export default {
  components: {
    Categories,
    Banner,
    ProductsCarousel,
    searchResults,
    Tag
  },
  data() {
    return {
      ...formFields(
        [
          "affiliation_type",
          "commission_percent",
          "commission_rule",
          "language",
          "category_select"
        ],
        {
          category_select: "all"
        }
      ),
      searchTerm: "",
      searchByCategory: this.$route.params.category,
      showOnlyLanguage: true,
      showFilter: false,
      orderBy: "",
      toolsOptions: [
        {
          id: 1,
          value: false,
          label: "Entrega de bônus"
        },
        {
          id: 2,
          value: false,
          label: "Links alternativos"
        },
        {
          id: 3,
          value: false,
          label: "Links alternativos dinâmicos"
        },
        {
          id: 4,
          value: false,
          label: "Materiais de divulgação"
        },
        {
          id: 5,
          value: false,
          label: "Rastreio de leads"
        }
      ],
      hotItems: [
        {
          id: 1,
          name: "Atuação",
          picture: require("@/assets/images/carousel-products/img-1.png")
        },
        {
          id: 2,
          name: "Make dia",
          picture: require("@/assets/images/carousel-products/img-2.png")
        },
        {
          id: 3,
          name: "Fotografia analógica",
          picture: require("@/assets/images/carousel-products/img-3.png")
        },
        {
          id: 4,
          name: "Culinária mexicana descomplicada",
          picture: require("@/assets/images/carousel-products/img-4.png")
        },
        {
          id: 5,
          name: "Como desenhar interfaces incríveis",
          picture: require("@/assets/images/carousel-products/img-5.png")
        }
      ]
    };
  },
  computed: {
    ...mapState("product", ["categories"]),
    results() {
      return this.searchTerm || this.searchByCategory;
    }
  },
  methods: {
    removeTag(val) {},
    selectCategory(val) {
      this.searchByCategory = val;
    }
  }
};
</script>
<style lang="scss" scoped>
.view-marketplace {
  i {
    font-size: 24px;
  }

  ::v-deep .icon {
    font-size: 24px;
    color: #928f98;
    padding-left: 4px;
  }

  ::v-deep .has-icon {
    .form-control {
      padding-left: 35px;
    }
  }

  ::v-deep .custom-switch {
    label {
      padding-top: 4px;
      padding-left: 6px;
    }
  }

  .container-select {
    width: 196px;
    padding-right: 16px;
  }

  .container-search {
    width: 372px;
  }
}
</style>
